/* eslint-disable react/no-unknown-property */
import React, { useState, useEffect } from "react";
import {
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { toast } from "react-toastify";
import MenuItem from "@mui/material/MenuItem";
import { createUser, editUser } from "../../services/userServices";
import FormHeader from "../Form/FormHeader";
import { handleApiError } from "../../utils/errorHandler";

export default function UserForm({
  title,
  initialValues,
  validationSchema,
  newUser,
  id,
}) {
  const navigate = useNavigate();

  const [showPass, setShowPass] = useState(false);
  const [showPassConfirmation, setShowPassConfirmation] = useState(false);
  const [showCurrentPass, setShowCurrentPass] = useState(false);

  const handlePassVisibility = () => {
    
    setShowPass(!showPass);
  };

  const handleCurrentPassVisibility = () => {
    
    setShowCurrentPass(!showCurrentPass);
  };

  const handlePassConfirmationVisibility = () => {
    
    setShowPassConfirmation(!showPassConfirmation);
  };

  const handleCancel = () => {
    navigate("/users");
  };

  const onSubmit = async (data) => {
    try {
      const response = newUser
        ? await createUser(data)
        : await editUser(data, id);
  
      navigate("/users");
      toast.success(
        newUser
          ? `Se ha agregado el nuevo usuario ${response.data.user.username}`
          : `Se han guardado los cambios de ${response.data.user.username}`
      );
    } catch (err) {
      if (!err?.response) {
        toast.error("No responde el servidor");
      } else {
        handleApiError(
          err,
          newUser
            ? "Error al agregar nuevo usuario"
            : "Error al actualizar usuario"
        );
      }
    }
  };
  

  return (
    <Container sx={{ padding: 5 }}>
      <FormHeader title={title} />
      <Paper elevation={2} sx={{ padding: 5 }}>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
          validateOnBlur={false}
          enableReinitialize={true}
        >
          {(props) => (
            <Form>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    name="name"
                    type="text"
                    fullWidth
                    label="Nombre"
                    variant="outlined"
                    autoFocus
                    error={!!props?.errors?.name && props?.touched?.name}
                    helperText={<ErrorMessage name="name" />}
                    value={props.values.name}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    name="lastName"
                    fullWidth
                    label="Apellido"
                    placeholder="Apellido"
                    variant="outlined"
                    error={
                      !!props?.errors?.lastName && props?.touched?.lastName
                    }
                    helperText={<ErrorMessage name="lastName" />}
                    value={props.values.lastName}
                  />
                </Grid>
              </Grid>
              <Grid container direction="row" spacing={2} sx={{ mt: 0.5 }}>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    name="email"
                    type="text"
                    fullWidth
                    label="Correo electrónico"
                    placeholder="Correo electrónico"
                    variant="outlined"
                    error={!!props?.errors?.email && props?.touched?.email}
                    helperText={<ErrorMessage name="email" />}
                    value={props.values.email}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    name="phone"
                    fullWidth
                    label="Teléfono"
                    placeholder="Teléfono"
                    variant="outlined"
                    error={!!props?.errors?.phone && props?.touched?.phone}
                    helperText={<ErrorMessage name="phone" />}
                    value={props.values.phone}
                  />
                </Grid>
              </Grid>
              <Grid container direction="row" spacing={2} sx={{ mt: 0.5 }}>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    name="username"
                    type="text"
                    fullWidth
                    label="Nombre de usuario"
                    placeholder="Nombre de usuario"
                    variant="outlined"
                    error={!!props?.errors?.name && props?.touched?.username}
                    helperText={<ErrorMessage name="username" />}
                    value={props.values.username}
                  />
                </Grid>
              </Grid>
              {!newUser && (
                <>
                  <Grid container direction="row" spacing={2} sx={{ mt: 0.5 }}>
                    <Grid item xs={6}>
                      <Field
                        as={TextField}
                        name="password"
                        type={showPass ? "text" : "password"}
                        fullWidth
                        label="Ingrese una contraseña"
                        placeholder="Contraseña"
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handlePassVisibility}
                                aria-label={
                                  showPass
                                    ? "Ocultar contraseña"
                                    : "Mostrar contraseña"
                                }
                                edge="end"
                              >
                                {showPass ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        error={
                          !!props?.errors?.password && props?.touched?.password
                        }
                        helperText={<ErrorMessage name="password" />}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Field
                        as={TextField}
                        name="confirmationPassword"
                        type={showPassConfirmation ? "text" : "password"}
                        fullWidth
                        label="Confirma la contraseña"
                        placeholder="Contraseña"
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handlePassConfirmationVisibility}
                                arial-label="toggle password"
                                edge="end"
                              >
                                {showPassConfirmation ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        error={
                          !!props?.errors?.confirmationPassword &&
                          props?.touched?.confirmationPassword
                        }
                        helperText={
                          <ErrorMessage name="confirmationPassword" />
                        }
                      />
                    </Grid>
                  </Grid>

                  <Grid container direction="row" spacing={2} sx={{ mt: 0.5 }}>
                    <Grid item xs={6}>
                      <Field
                        as={TextField}
                        name="currentPassword"
                        type={showCurrentPass ? "text" : "password"}
                        fullWidth
                        label="Contraseña actual"
                        placeholder="Contraseña"
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleCurrentPassVisibility}
                                arial-label="toggle password"
                                edge="end"
                              >
                                {showCurrentPass ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        error={
                          !!props?.errors?.currentPassword &&
                          props?.touched?.currentPassword
                        }
                        helperText={<ErrorMessage name="currentPassword" />}
                      />
                    </Grid>
                  </Grid>
                </>
              )}

              <Grid container direction="row" spacing={2} sx={{ mt: 3 }}>
                <Grid item>
                  <Button variant="contained" type="submit">
                    Guardar
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="outlined" onClick={handleCancel}>
                    Cancelar
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Paper>
    </Container>
  );
}
